import type { AdminMessages } from './admin';

export const zhAdmin: AdminMessages = {
  userManagement: {
    title: '用户管理',
    createAccount: '创建',
    colUsername: '用户名',
    colEmail: '邮箱',
    colRole: '角色',
    colCreatedAt: '创建时间',
    colStatus: '状态',
    colActions: '操作',
    blockUser: '封禁用户',
    activateUser: '启用用户',
    dialogTitle: '创建新账户',
    email: '邮箱',
    password: '密码',
    confirmPassword: '确认密码',
    submitCreate: '创建账户',
  },
  staffManagement: {
    title: '员工管理',
    addStaff: '添加员工',
    colUsername: '用户名',
    colEmail: '邮箱',
    colRole: '角色',
    colStatus: '状态',
    colCreatedAt: '创建时间',
    colActions: '操作',
    edit: '编辑',
    promote: '提升为管理员',
    block: '封禁账户',
    activate: '启用账户',
    editDialogTitle: '编辑员工',
    createDialogTitle: '创建新员工账户',
    username: '用户名',
    email: '邮箱',
    password: '密码',
    saveChanges: '保存更改',
    create: '创建',
  },
  userStaffManagement: {
    title: '员工账户',
    subtitle: '为此账户创建并管理员工登录。员工只能查看照片和设备。',
    add: '添加员工',
    empty: '还没有员工账户',
    emptyHint: '创建员工账户，让同事可以查看照片和设备。',
    listTitle: '员工列表',
    statTotal: '员工总数',
    statActive: '启用',
    statBlocked: '已封禁',
    statTotalShort: '总数',
    statActiveShort: '启用',
    statBlockedShort: '封禁',
    colUsername: '用户名',
    colEmail: '邮箱',
    colStatus: '状态',
    colCreatedAt: '创建时间',
    colActions: '操作',
    edit: '编辑',
    block: '封禁',
    activate: '启用',
    createTitle: '创建员工账户',
    editTitle: '编辑员工账户',
    email: '邮箱',
    password: '密码',
    username: '用户名',
    usernameOptional: '用户名（可选）',
    usernameHint: '留空则根据邮箱生成',
    newPassword: '新密码',
    newPasswordHint: '留空则保持当前密码',
    cancel: '取消',
    create: '创建',
    save: '保存',
    emailPasswordRequired: '邮箱和密码为必填',
    loadFail: '加载员工失败',
    createOk: '员工账户已创建',
    createFail: '创建员工失败',
    updateOk: '员工账户已更新',
    updateFail: '更新员工失败',
    toggleFail: '更新状态失败',
  },
  customFrames: {
    title: '自定义相框管理',
    addNew: '添加新相框',
    filterBySize: '按相框尺寸筛选',
    empty: '还没有自定义相框',
    emptyFiltered: '没有符合当前筛选的相框',
    photosCount: '{n} 张照片',
    active: '启用',
    inactive: '停用',
    createdBy: '创建者：{name}',
    created: '创建时间：{date}',
    editFrame: '编辑相框',
    deleteFrame: '删除相框',
    endOfList: '已显示全部 {n} 个自定义相框（共 {total}）',
    createDialog: '创建新的自定义相框',
    editDialog: '编辑自定义相框',
    frameName: '相框名称',
    size: '尺寸',
    designLink: '设计链接',
    designLinkPlaceholder: '输入设计链接',
    designLinkHelper: '设计文件或页面的链接',
    createFrame: '创建相框',
    updateFrame: '更新相框',
    deleteDialogTitle: '删除自定义相框',
    deleteConfirm: '确定删除此自定义相框吗？',
  },
  albums: {
    title: '相册页面管理',
    subtitle: '创建不同的相册链接，并自定义封面和背景图。',
    createNew: '创建新相册页',
    creating: '创建中…',
    empty: '还没有相册页。',
    pathSuffix: '路径后缀',
    albumLink: '相册链接',
    coverImage: '封面图',
    noCover: '还没有封面图',
    enabled: '已启用',
    disabled: '已停用',
    editDialog: '编辑相册页',
    createDialog: '创建相册页',
    pageName: '相册页名称',
    isActive: '启用',
    pageList: '页面列表',
    pageOrder: '顺序',
    coverPage: '第 01 页 - 相册封面',
    coverPageHint: '编辑名称/别名、封面和背景图',
    framePage: '第 {n} 页 - {name}',
    demoPreview: '相册界面演示',
    pageSettings: '页面设置',
    coverPhoto: '封面照片',
    backgroundPhoto: '背景照片',
    selectCover: '选择封面',
    selectBackground: '选择背景',
    removeCover: '移除封面',
    uploading: '上传中...',
    pickPageHint: '选择一个页面以编辑设置。',
    saveChanges: '保存更改',
    create: '创建',
  },
  landing: {
    title: '落地页（后端 HTML）',
    subtitle: '选择经典表单或拖放画布。完成后请记得保存。',
    classicForm: '经典表单',
    canvasMode: '拖放画布',
    publicLabel: '公开：',
    copy: '复制',
    open: '打开',
    settingsTitle: '内容设置',
    reload: '重新加载',
    loading: '加载中…',
    saveConfig: '保存配置',
    saving: '保存中…',
    unsavedTitle: '未保存的更改',
    unsavedBody: '离开前要保存吗？',
    stay: '留下',
    leaveWithoutSave: '不保存并离开',
    saveAndLeave: '保存并离开',
  },
  desktops: {
    title: '桌面端管理',
    refresh: '刷新',
    totalMachines: '共 {n} 台机器',
    colMachineCode: '机器代码',
    colRandomCode: '随机码',
    colMachineName: '机器名称',
    colUser: '用户',
    colStatus: '状态',
    colType: '类型',
    colCreatedAt: '创建时间',
    colUpdatedAt: '更新时间',
    colActions: '操作',
    active: '启用',
    inactive: '停用',
    connected: '已连接',
    disconnected: '已断开',
    unknownType: '未知',
    updateRandomCode: '更新随机码',
    previous: '上一页',
    next: '下一页',
    pageOf: '第 {page} 页，共 {totalPages} 页',
    dialogTitle: '更新随机码',
    dialogConfirm: '为此机器生成新的随机码？',
    currentRandomCode: '当前随机码',
    update: '更新',
  },
  softwareUpdate: {
    title: '软件更新',
    refresh: '刷新',
    dropActive: '把文件拖到这里',
    dropIdleApk: '把 .apk 文件拖到这里，或点击选择',
    dropIdleExe: '把 .exe 文件拖到这里，或点击选择',
    currentChannel: '当前通道：{channel}',
    hintApk: '只允许 .apk 文件，最大 1GB',
    hintExe: '只允许 .exe 文件，最大 1GB',
    uploading: '正在上传文件...',
    currentFile: '当前文件',
    fileName: '文件名',
    fileSize: '大小',
    uploadDate: '上传日期',
    uploadedBy: '上传者',
    download: '下载',
    empty: '还没有上传更新文件',
    updateInfo: '更新信息',
    saveInfo: '保存信息',
    saving: '保存中...',
    deleteTitle: '确认删除',
    deleteConfirm: '确定删除此更新文件吗？',
    deleting: '删除中...',
  },
  email: {
    tabCompose: '撰写邮件',
    tabSent: '已发送',
    title: '邮件',
    subject: '邮件主题',
    subjectPlaceholder: '输入邮件主题...',
    bodyLabel: '邮件正文（HTML）',
    bodyPlaceholder: '输入邮件正文...',
    recipientList: '邮箱列表',
    recipientPlaceholder: '输入邮箱后按空格…',
    clearAll: '全部清除',
    clearAllConfirm: '清除全部邮箱？',
    sendingProgress: '发送中：{sent}/{total} 封',
    cancelSendConfirm: '确定要取消吗？',
    send: '发送邮件',
    sending: '发送中...',
    search: '搜索',
    searchPlaceholder: '按收件人/主题/发件人搜索...',
    deleteSelected: '删除',
    deleteConfirm: '删除 {n} 封已发送邮件？',
    colSubject: '主题',
    colPreview: '预览',
    colRecipients: '收件人',
    colStats: '统计',
    colTime: '时间',
    empty: '还没有邮件',
    statsChip: '{sent} 已发送 / {failed} 失败',
    recipientsCount: '{n} 位收件人',
    pageOf: '第 {page} / {totalPages} 页',
    prev: '上一页',
    next: '下一页',
    detailTitle: '邮件详情',
    noData: '没有数据',
  },
  userDetail: {
    userNotFound: '未找到用户',
    tabs: {
      profile: '资料',
      pro: 'Pro',
      proFull: 'M-Photo Pro',
      lite: 'Lite',
      liteFull: 'M-Photo Lite',
      mono: 'Mono',
      monoFull: 'M-Photo Mono',
      frame: '相框',
      frameFull: '自定义相框',
      media: '媒体',
      device: '设备',
      deviceFull: '设备管理',
      sepay: 'SePay',
      staff: '员工',
    },
    deviceAccess: '设备权限',
    deviceAccessHint: '为此账户开启或关闭产品。',
    uploadMethod: '图库上传方式',
    uploadMethodHint: '此账户下的拍照机器如何上传照片/视频。',
    uploadMethodServer: '传统（经服务器）',
    uploadMethodServerDesc: '应用把文件发给 API；服务器再上传到 Firebase。',
    uploadMethodSigned: '直传（签名链接）',
    uploadMethodSignedDesc: '服务器签发临时链接；应用直接上传到 Firebase。',
    toastUploadMethodUpdated: '上传方式已更新',
    toastUploadMethodFail: '无法更新上传方式',
    accountTitle: '账户信息',
    accountHint: '更新此用户的账户资料',
    roleUser: '用户',
    roleAdmin: '管理员',
    roleStaff: '员工',
    statusActive: '启用',
    statusInactive: '停用',
    changePassword: '修改密码',
    changePasswordHint: '管理员可以为此用户设置新密码',
    newPassword: '新密码',
    confirmAsAdmin: '以管理员身份确认',
    adminPassword: '管理员密码',
    confirm: '确认',
    deviceSettings: '设备设置',
    toggleDevice: '设备',
    toggleDeviceFull: '开启设备管理',
    toggleDeviceDesc: '开启二维码 / 设备管理',
    toggleEdit: '编辑',
    toggleEditFull: '编辑页',
    toggleEditDesc: 'M-Photo Pro 上的编辑按钮',
    toggleMerge: '合并',
    toggleMergeFull: '多张拍摄',
    toggleMergeDesc: '合并拍摄 / 合并打印',
    toggleBgRemoval: '背景',
    toggleBgRemovalFull: '去除背景',
    toggleBgRemovalDesc: '在 M-Photo Pro 上去除 AI 背景，以及自定义相框背景',
    machinesTitle: '用户机器',
    machinesCount: '{n} 台机器',
    deviceOffWarning: '设备已关闭 — 仍可查看已注册的机器。',
    noMachines: '还没有机器。',
    tabPrev: '上一标签',
    tabNext: '下一标签',
    on: '开',
    off: '关',
    toastLoadUserFail: '加载用户信息失败',
    toastDeviceUpdated: '设备管理状态已更新',
    toastDeviceUpdateFail: '更新设备管理状态失败',
    toastEditOn: '编辑页已开启',
    toastEditOff: '编辑页已关闭',
    toastEditFail: '更新编辑页状态失败',
    toastMergeOn: '多张拍摄已开启',
    toastMergeOff: '多张拍摄已关闭',
    toastMergeFail: '更新多张拍摄状态失败',
    toastBgRemovalOn: '去背景已开启',
    toastBgRemovalOff: '去背景已关闭',
    toastBgRemovalFail: '更新去背景状态失败',
    toastAccessUpdated: '设备权限已更新',
    toastAccessFail: '更新设备权限失败',
    toastStatusUpdated: '用户状态已更新',
    toastStatusFail: '更新用户状态失败',
    toastUsernameEmailRequired: '用户名和邮箱为必填',
    toastInfoUpdated: '用户信息已更新',
    toastInfoFail: '更新用户信息失败',
    toastNeedNewPassword: '请输入新密码',
    toastNeedAdminPassword: '请输入管理员密码',
    toastPasswordUpdated: '用户密码已更新',
    toastPasswordFail: '更新用户密码失败',
    toastMachinesFail: '加载用户机器失败',
    toastMachineDetailFail: '加载机器详情失败',
    toastCopiedCode: '已复制随机码',
    toastCopiedLink: '已复制上传链接',
    toastCopyFail: '无法复制文本',
    toastAvatarType: '请选择图片文件',
    toastAvatarOk: '头像已更新',
    toastAvatarFail: '无法更新头像',
  },
  backgroundAi: {
    title: 'Background AI',
    subtitle: '共用 Fal 和 PiAPI 密钥。每个账户自行选择提供商、质量和模型。',
    providerTitle: '提供商',
    using: '正在使用 {name}',
    balance: ' · 余额 {n}{usd} 额度',
    quality: '质量',
    qualityLow: '低',
    qualityMedium: '中',
    qualityHigh: '高',
    chooseModel: '选择模型',
    openList: '点击打开列表',
    noModels: '没有图片模型。',
    falKey: 'Fal 密钥',
    piapiKey: 'PiAPI 密钥',
    noKey: '还没有 {name} 密钥',
    revealCountdown: '已确认 · 还剩 {s} 秒后再次要求密码',
    keyHint: '粘贴新密钥以替换。眼睛按钮可查看密钥（需要管理员密码）。',
    saveProvider: '保存密钥',
    falBalance: 'Fal 余额：{amount}',
    falBalanceLoading: '正在查询 Fal 余额...',
    saving: '保存中...',
    missingKey: '所选提供商没有 API 密钥。请在上方粘贴，或在 .env 中设置 PIAPI_API_KEY / FAL_KEY。',
    presetsTitle: '背景',
    loading: '加载中...',
    presetCount: '{n} 项',
    reload: '重新加载',
    createNew: '新建背景',
    noPresets: '还没有背景。用提示词和预览图创建一个。',
    accountsTitle: '账户管理',
    statsTitle: '统计',
    enabledCount: '已开启 {n} 个',
    searchUsers: '搜索用户名或邮箱',
    noUsers: '没有匹配的用户。',
    usageHistory: '生成记录',
    themeList: 'AI 主题列表',
    themeDialog: 'AI 主题',
    noUserThemes: '此账户还没有 AI 主题。',
    addTheme: '添加 AI 主题',
    editTheme: '编辑 AI 主题',
    themeName: '主题名称',
    themeDescription: '说明',
    themeImage: '主题图片',
    backgrounds: 'AI 背景',
    backgroundCount: '{n} 个 AI 背景',
    addBackground: '添加 AI 背景',
    editBackground: '编辑 AI 背景',
    backgroundName: '背景名称',
    tags: '标签',
    tagMale: '男',
    tagFemale: '女',
    tagGroup: '团体',
    tagsRequired: '请至少选择一个标签。',
    confirmDeleteTheme: '删除此 AI 主题及其全部背景？',
    confirmDeleteBackground: '删除此 AI 背景？',
    emptyBackgrounds: '此主题还没有 AI 背景。',
    back: '返回',
    accountGenHint: 'API 密钥仍然共用。这里的提供商、质量和模型只作用于此账户的 mlite 和手机上传。',
    accountGenSaved: '已保存此账户的图片设置',
    accountGenFail: '无法保存图片设置',
    multiSlotTitle: '多照片相框的 AI',
    multiSlotHint: '开启后，含 2 张或更多照片的相框可以生成 AI 图片。每张照片是一次提供商请求。',
    multiSlotConfirm: '费用会更高，因为相框中的每张照片都会单独生成。要开启吗？',
    multiSlotConfirmTitle: '开启多照片 AI？',
    multiSlotConfirmYes: '开启',
    multiSlotImages: '{n} 张照片',
    quotaTitle: '剩余 AI 次数',
    quotaHint: '保存的数字就是剩余次数。每生成一张照片用掉一次。留空表示不限。',
    quotaPlaceholder: '不限',
    quotaUsed: '已用：{n}',
    quotaRemaining: '剩余：{n}',
    quotaUnlimited: '不限',
    usageTitle: 'AI 生成 · {name}',
    usageEmpty: '此账户还没有 AI 生成记录。',
    usageMachine: '机器 {code}',
    usageMachineNamed: '{name}（{code}）',
    usageUnnamed: '{kind} 机器',
    usageShowing: '{n} 次生成',
    usageCostTotal: '合计 ${amount}',
    usageCostCalculating: '计算中',
    usageChart2m: '2 个月',
    usageChart1m: '1 个月',
    usageChart2w: '2 周',
    usageChart1w: '1 周',
    usageChart7d: '7 天',
    usageChart1d: '1 天',
    usageChart2d: '2 天',
    usageChartFrom: '从',
    usageChartTo: '到',
    usageChartAccounts: '账户',
    usageChartAllAccounts: '全部账户',
    usageLoadMore: '加载更多',
    usageTheme: '主题',
    usageBackground: '背景',
    usageSearch: '搜索机器名称',
    usageSubjectStats: '使用统计',
    usageSubjectEmpty: '此范围内没有生成记录',
    usageSubjectUnknown: '未知',
    usageSubjectDayHint: '点击某一天查看当天',
    usageSubjectWholeRange: '整个范围',
    usageSubjectTabUse: '使用',
    usageSubjectMoney: '花费',
    usageSubjectMoneyEmpty: '此范围内没有花费',
    usageCostRateLimit: 'Fal 正在限制价格查询。请稍等，然后重新打开统计。',
    usageFilterAll: '全部',
    usageNoMatch: '没有匹配的机器。',
    usageLoadFail: '无法加载 AI 生成记录',
    editPreset: '编辑 AI 背景',
    createPreset: '创建 AI 背景',
    presetName: '名称',
    prompt: '背景提示词',
    promptHelper: '只描述背景。照片中的人保持不变。',
    chooseImage: '选择预览图',
    cancel: '取消',
    save: '保存',
    create: '创建',
    revealTitle: '确认 — 查看 API 密钥',
    revealBody: '输入当前登录的管理员账户密码。正确后，5 分钟内不会再次询问。',
    adminPassword: '管理员密码',
    view: '查看',
    toastLoadPresetsFail: '无法加载 AI 背景',
    toastLoadUsersFail: '无法加载用户',
    toastNamePromptRequired: '请输入名称和背景提示词',
    toastPresetSaved: 'AI 背景已保存',
    toastPresetCreated: 'AI 背景已创建',
    toastPresetSaveFail: '无法保存 AI 背景',
    toastPresetDeleted: 'AI 背景已删除',
    toastPresetDeleteFail: '无法删除 AI 背景',
    toastDeleteConfirm: '删除“{name}”？',
    toastUserToggleFail: '无法更新用户权限',
    toastPasswordRequired: '请输入管理员账户密码。',
    toastPasswordWrong: '密码不正确。',
    toastQualityFail: '无法保存质量',
    toastModelSelected: '已选择 {model}',
    toastModelFail: '无法保存模型',
    toastProviderSwitched: 'API 密钥已保存',
    toastProviderFail: '无法保存 AI 提供商',
    toastCatalogFail: '无法加载模型列表',
  },
};
